import { toast } from "@/components/ui/use-toast";
import { apiClient } from "@/lib/api/client";
import { handleApiError } from "@/lib/api/error";
import { useTranslation } from "@/lib/i18n";
import { queryClient } from "@/lib/queryClient";
// TODO: domainがRouteの依存を持つのは避けたい。domain内部でkeyを管理するようにする
import { appIntegrationKey } from "@/routes/_staff/app-integrations/$id/_$id/-query/key";
import { useMutation } from "@tanstack/react-query";

type Options = {
  appIntegrationId: string;
  appUserId: string;
  onSuccess?: () => void;
};

export default function useAppUserChangeWorker({
  appIntegrationId,
  appUserId,
  onSuccess,
}: Options) {
  const { i18n } = useTranslation();

  return useMutation({
    mutationFn: async (personId: string) => {
      const save = await apiClient.PUT(
        "/v3/app-integrations/{id}/users/{appUserId}/worker",
        {
          params: { path: { id: appIntegrationId, appUserId } },
          body: { personId },
        },
      );
      return save;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: appIntegrationKey.all(appIntegrationId),
      });
      // TODO:Alertのキーを確認する
      await queryClient.invalidateQueries({
        queryKey: ["alerts"],
      });
      toast({ title: "Success!!" });
      onSuccess?.();
    },
    onError: (error) => {
      const { message } = handleApiError(error, {
        language: i18n.language,
      });
      toast({ title: message });
    },
  });
}
